module.exports = __webpack_public_path__ + "static/class-testing-131bd4ecb996e36580cf1e62c1ff8163.jpg";